import React from 'react';

export default class ProjectInfo extends React.Component {
  render() {
    return (
      <div className="project-information">
        <img src={this.props.projectImage} alt={this.props.projectImage} style={{width: '100%', height: '150px', objectFit: 'contain'}} />
        <h1>{this.props.project.name}</h1>
        <div>
          {this.props.project.stack.split(', ').map(function(s, i) {
            return <h4 key={i}>{ s }</h4>;
          })}
        </div>
        <br/>
        <h3>
          {this.props.project.background}
        </h3>
        <br/>
        {/*this.props.project.url !== null ?
          (<h5 onClick={()=> window.open(this.props.project.url, "_blank")} style={{cursor: 'pointer'}}>
            View The Website
          </h5>)
          : null
        */}
        <p onClick={() => this.props.nextProject(this.props.projectIdx)} style={{position: 'absolute', right: '20px', bottom: '0', cursor: 'pointer'}}>Next</p>
      </div>
    );
  }
}
